<script>
import HeaderView from '../../../shared/views/HeaderView';
import MainMenuInstructorView from '../../../shared/views/MainMenuInstructorView';
import ListInstructorLiveClassView from '../lists/ListInstructorLiveClassView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';

export default {
  name: 'ModuleInstructorLiveClassView',
  components: {
    'header-view': HeaderView,
    'main-menu-instructor-view': MainMenuInstructorView,
    'list-instructor-live-class-view': ListInstructorLiveClassView,
  },
  data() {
    return {};
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <header-view />
    <main-menu-instructor-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <div class="stream_page_header">
                  <div class="stream_header_left">
                    <div class="stream_header_icon">
                      <i class="fas fa-broadcast-tower" />
                    </div>
                    <div class="stream_header_text">
                      <h4 class="item_title">
                        Todas las Clases en Vivo
                      </h4>
                      <p class="stream_header_subtitle">
                        Gestiona tus sesiones en directo y grabaciones publicadas para tus estudiantes
                      </p>
                    </div>
                  </div>
                </div>
                <div class="la5lo1">
                  <list-instructor-live-class-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
